import React from 'react';
import { useHistory } from 'react-router';
import { useIntl } from 'react-intl';
import CustomBtn from '../../generic/CustomBtn/CustomBtn';
import { queueToastifyMessage } from '../Toastify/Toastify';

const RequestModal = ({ error, title, description, handleClose, buttonText, buttonClass = '', click }) => {
  const history = useHistory();
  const translate = useIntl();

  const redirectToMain = () => {
    queueToastifyMessage(translate.formatMessage({ id: 'smart-contract-notify' }));
    history.push('/');
  };

  return (
    <div className="wizard__popup">
      <div className="wizard__popup-bg" />
      <div className="wizard__popup-wrapper">
        {error ? (
          <>
            <div className="wizard__popup-desc">
              <h2 className="title">{title}</h2>
              <div className="text-block">
                <p className="text">{description}</p>
              </div>
            </div>
            <div className={`wizard__popup-btn ${buttonClass}`}>
              <CustomBtn
                label={buttonText || translate.formatMessage({ id: 'button-close' })}
                handleClick={handleClose}
                customClass="btn__confirmation"
              />
            </div>
          </>
        ) : (
          <>
            <div className="wizard__popup-logo">
              <i className="icon-check-circle" />
            </div>
            <div className="wizard__popup-desc">
              <h2 className="title">{title}</h2>
              <div className="text-block">
                <p className="text paragraphIndents">{description}</p>

              </div>
            </div>
            <div className={`wizard__popup-btn ${buttonClass}`}>
              <CustomBtn
                label={buttonText || translate.formatMessage({ id: 'acc.btn-label' })}
                handleClick={() => (click ? click() : redirectToMain())}
                customClass="btn__confirmation"
              />
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default RequestModal;
